// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7OI8e","questions":"styles_questions__2CiCy","footer":"styles_footer__3Ngd-"};